<template>
  <div>
    <div class="logo-bg" v-if="hasCreaAsta">
      <div class="view">
        <div class="crea-asta">
          <v-card
            class="navy darken-2 white--text py-4 px-8 ma-5"
            max-width="400"
          >
            <!-- @submit.stop.prevent="createAsta" -->
            <!-- lazy-validation -->
            <!-- we use vuelidate -->
            <h1 class="text-center mb-5">Crea asta</h1>
            <v-form ref="form" v-model="valid">
              <v-text-field
                label="Nome lega/asta"
                v-model="astaName"
                :rules="[rules.campoObbligatorio, rules.nomeTroppoLungo(50)]"
                counter
                maxlength="50"
                prepend-icon="shield"
                persistent-hint
                required
                outlined
                dark
                append-outer-icon="lock_open"
              ></v-text-field>

              <v-select
                v-model="maxSquadre"
                :items="[
                  2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                  19, 20,
                ]"
                :rules="[rules.campoObbligatorio]"
                label="Numero squadre partecipanti"
                prepend-icon="groups"
                append-outer-icon="lock_open"
                required
                outlined
                dark
              ></v-select>

              <v-select
                v-model="tipologiaRuoli"
                :items="getAstaRuoliSelectOptions()"
                label="Tipologia ruoli"
                prepend-icon="tune"
                append-outer-icon="lock_open"
                required
                outlined
                dark
              ></v-select>

              <v-text-field
                label="Crediti iniziali"
                :rules="[rules.creditiLega]"
                v-model.number="creditiLega"
                type="number"
                name="creditiLega"
                prepend-icon="local_atm"
                append-outer-icon="lock_open"
                persistent-hint
                required
                outlined
                dark
              ></v-text-field>

              <v-select
                v-model="mode"
                :items="getAstaModesSelectOptions()"
                label="Modalità d'asta"
                prepend-icon="gavel"
                required
                outlined
                dark
                hint="Non ti preoccupare della scelta adesso. Puoi cambiare in qualunque momento la modalità di un'asta"
              ></v-select>

              <!-- <div class="ruoli">
                <v-select
                  v-model="nP"
                  :items="[1, 2, 3, 4, 5]"
                  :rules="[rules.campoObbligatorio]"
                  label="Por"
                  required
                  outlined
                  dark
                ></v-select>
                <v-select
                  v-model="nD"
                  :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                  :rules="[rules.campoObbligatorio]"
                  label="Dif"
                  required
                  outlined
                  dark
                ></v-select>
                <v-select
                  v-model="nC"
                  :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                  :rules="[rules.campoObbligatorio]"
                  label="Cen"
                  required
                  outlined
                  dark
                ></v-select>
                <v-select
                  v-model="nA"
                  :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                  :rules="[rules.campoObbligatorio]"
                  label="Att"
                  required
                  outlined
                  dark
                ></v-select>
              </div> -->

              <h3 class="text-center mb-3">La mia squadra</h3>
              <v-row dense>
                <v-col cols="3">
                  <div class="myPic" :class="myPicClass" @click="showDialog">
                    <label class="label">Logo</label>
                    <img v-if="myPic" :src="myPic" />
                  </div>
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    label="Nome squadra"
                    v-model="myNomeSquadra"
                    name="myNomeSquadra"
                    persistent-hint
                    required
                    outlined
                    class="mb-4"
                    counter
                    maxlength="50"
                    :rules="[
                      rules.campoObbligatorio,
                      rules.nomeTroppoLungo(50),
                    ]"
                    dark
                  ></v-text-field>
                </v-col>
              </v-row>

              <div>
                Importante: I campi contrassegnati con
                <v-icon class="white--text">lock_open</v-icon> non saranno più
                modificabili una volta creata l'asta
              </div>

              <div class="mt-4">
                Dopo aver creato l'asta, troverai però molte altre opzioni da
                personalizzare
              </div>

              <v-btn
                rounded
                depressed
                large
                id="crea-asta"
                class="secondary white--text mt-4"
                @click="createAsta"
                :disabled="!valid"
                >Crea Asta</v-btn
              >
            </v-form>
          </v-card>
          <v-dialog eager v-model="dialog" max-width="700">
            <v-card class="navy darken-1">
              <v-card-title class="white--text">Scegli logo</v-card-title>
              <v-divider></v-divider>
              <div class="pics" :class="{ 'nice-scroll': !is_mobile }">
                <div
                  v-for="(pic, index) in defaultPics"
                  :key="index"
                  class="pic navy darken-2"
                  @click="saveMyPic(pic)"
                >
                  <img :src="pic" />
                </div>
              </div>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
    <NotFound v-else></NotFound>
  </div>
</template>

<script>
import Config from "../../../config-app/config";
import authentication from "../../js/auth";
import db from "../../js/db";
import toast from "../../js/toast";
import Constants from "../../js/constants";
import NotFound from "./NotFound";
import Vuex from "vuex";
import mixins from "../../js/mixins";

export default {
  name: "crea-asta",
  mixins: [mixins, toast],
  components: { NotFound },
  data() {
    return {
      firebase_host: Config.FIREBASE_HOST,
      dialog: false,
      hasCreaAsta: Config.CREA_ASTA,
      valid: false,
      astaName: "",
      maxSquadre: 8,
      myNomeSquadra: "",
      creditiLega: 250,
      tipologiaRuoli: Constants.TIPO_RUOLI.CLASSIC,
      nP: 3,
      nD: 8,
      nC: 8,
      nA: 6,
      myPic: "",
      myPicClass: "",
      mode: Constants.ASTA_MODE.SELVAGGIA,
      rules: {
        campoObbligatorio: (v) => !!v || "Campo obbligatorio",
        nomeTroppoLungo(nCharMax) {
          return (v) => (v || "").length <= nCharMax || "Nome troppo lungo";
        },
        creditiLega: (v) => {
          v = v || 0;
          if (v < 100 || v > 1000) {
            return "Deve essere compreso tra 100 e 1000";
          }
          return true;
        },
      },
    };
  },
  methods: {
    showDialog() {
      this.myPicClass = "";
      this.dialog = true;
    },
    saveMyPic(pic) {
      this.myPic = pic;
      this.dialog = false;
    },
    async createAsta() {
      if (!this.myPic) {
        this.errorToast("Errore", "Selezionare il logo");
        this.myPicClass = "mancante";
        return;
      }
      try {
        const asta_id = await db.createAstaESquadra(
          this.astaName,
          this.user_uid,
          this.maxSquadre,
          this.creditiLega,
          this.nP,
          this.nD,
          this.nC,
          this.nA,
          this.myNomeSquadra,
          this.myPic,
          this.mode,
          this.tipologiaRuoli
        );
        this.successToast(
          "Complimenti, asta creata!",
          "Ora invita gli altri partecipanti dal menu a sinistra"
        );

        this.$router.push({
          name: "asta",
          params: { id: asta_id },
          query: { showInvito: 1 },
        });
      } catch (error) {
        this.errorToast(
          "Errore mentre si tentava di creare l'asta. Riprova.",
          error.message
        );
      }
    },
  },
  mounted() {
    console.log("CreaAsta mounted.");
  },
  destroyed() {
    console.log("CreaAsta destroyed.");
  },
  computed: {
    ...Vuex.mapGetters(["is_mobile"]),
    // hintMaxSquadre() {
    //     return "Puoi giocare un'asta anche se si iscrovono meno partecipanti di quelli impostati qui (basta che se ne iscrivano almeno 2)"
    // }
  },
};
</script>


<style lang="scss" scoped>
@import "../../main.scss";

.view {
  // height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .crea-asta {
    // background-color: var(--v-primary-base);
    // background-image: repeating-linear-gradient(-14deg, #4db6ac, #009688 530px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    .ruoli {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
    }

    label,
    input,
    .v-messages__message,
    .v-input__icon {
      color: white !important;
    }

    #crea-asta.v-btn--disabled {
      background: rgb(255 255 255 / 33%) !important;
    }

    .myPic {
      border-radius: 4px;
      width: 56px;
      height: 56px;
      border: 1px solid hsla(0, 0%, 100%, 0.24);
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      cursor: pointer;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      &.mancante {
        border: 2px solid var(--v-error-base);
        .label {
          color: var(--v-error-base) !important;
        }
      }
      &:not(.mancante):hover {
        border-color: white;
      }
      .label {
        position: absolute;
        color: rgba(255, 255, 255, 0.8) !important;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        font-size: 14px;
        line-height: 56px;
        cursor: pointer;
      }
      img {
        height: 95%;
        width: 95%;
        z-index: 1;
        position: relative;
        cursor: pointer;
        background: #2e434c;
        border-radius: 2px;
      }
    }
  }
}

.pics {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  padding: 10px;
  overflow-y: auto;
  max-height: 450px;
  .pic {
    height: 100px;
    width: 100px;
    border-radius: 4px;
    overflow: hidden;
    &:hover {
      opacity: 0.8;
    }
    img {
      cursor: pointer;
      border-radius: 4px;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
